import type {CopilotChatState} from '../copilot-chat-reducer'
import {CopilotLicenseType} from '../copilot-chat-types'
import {copilotFeatureFlags} from '../copilot-feature-flags'

export function taskOrientedAssistiveEnabled(licenseType: CopilotLicenseType | null): boolean {
  return !!licenseType && licenseType !== CopilotLicenseType.Unlicensed && copilotFeatureFlags.taskOrientedAssistive
}

export function shouldRenderTaskOrientedAssistive(
  state: CopilotChatState,
  licenseType: CopilotLicenseType | null,
): boolean {
  if (!taskOrientedAssistiveEnabled(licenseType)) {
    return false
  }

  const context = state.context?.[0] ?? state.currentTopic
  if (!context) {
    return false
  }

  const type = 'type' in context && typeof context.type === 'string' ? context.type : 'repository'

  return type === 'pull-request'
}
